"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var AddCircle = function AddCircle(props) {
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M13.1248 19.5416H14.8748V14.875H19.5415V13.125H14.8748V8.45829H13.1248V13.125H8.45817V14.875H13.1248V19.5416ZM14.0019 25.0833C12.4689 25.0833 11.0279 24.7924 9.67909 24.2106C8.33023 23.6289 7.15695 22.8393 6.15925 21.842C5.16156 20.8447 4.37163 19.6719 3.78946 18.3236C3.20749 16.9753 2.9165 15.5348 2.9165 14.002C2.9165 12.469 3.20739 11.0281 3.78917 9.67921C4.37095 8.33035 5.16049 7.15707 6.1578 6.15938C7.1551 5.16168 8.32789 4.37175 9.67617 3.78958C11.0244 3.20761 12.465 2.91663 13.9978 2.91663C15.5308 2.91663 16.9717 3.20751 18.3206 3.78929C19.6695 4.37107 20.8427 5.16061 21.8404 6.15792C22.8381 7.15522 23.628 8.32802 24.2102 9.67629C24.7922 11.0246 25.0832 12.4651 25.0832 13.9979C25.0832 15.5309 24.7923 16.9719 24.2105 18.3207C23.6287 19.6696 22.8392 20.8428 21.8419 21.8405C20.8446 22.8382 19.6718 23.6282 18.3235 24.2103C16.9752 24.7923 15.5347 25.0833 14.0019 25.0833ZM13.9998 23.3333C16.6054 23.3333 18.8123 22.4291 20.6207 20.6208C22.429 18.8125 23.3332 16.6055 23.3332 14C23.3332 11.3944 22.429 9.18746 20.6207 7.37913C18.8123 5.57079 16.6054 4.66663 13.9998 4.66663C11.3943 4.66663 9.18734 5.57079 7.379 7.37913C5.57067 9.18746 4.6665 11.3944 4.6665 14C4.6665 16.6055 5.57067 18.8125 7.379 20.6208C9.18734 22.4291 11.3943 23.3333 13.9998 23.3333Z",
    fill: "#023C40"
  }));
};
AddCircle.propTypes = _inline_svg2.default.propTypes;
AddCircle.defaultProps = _inline_svg2.default.defaultProps;
var _default = AddCircle;
exports.default = _default;